<template>
  <div class="login-box">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'LoginIndex',
}
</script>

<style lang="scss" scoped>
::v-deep {
  .title {
    margin-bottom: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }

  .el-form-item__label {
    line-height: 36px;
  }

  .el-form-item  {
    margin-bottom: 24px;
  }

  .sub-btn {
    display: block;
    margin: 40px auto 0;
  }

  .err-msg {
    margin-top: 6px;
    font-size: 12px;
    color: #F56C6C;
    text-align: center;
  }
}

.login-box {
  margin: 100px auto 0;
  width: 450px;
  height: calc(100vh - 282px);
}
</style>
